export const productCatalogue = {
  pageView: () => ({
    event_name: 'page_view, journey_start',
    page_name: 'vodapay: business advance: opf: funding options',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  nextClick: (productName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: funding options',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: funding options: next',
    event_category: productName
  }),

  backClick: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: funding options',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: funding options: back'
  })
};
